import { render } from "./SpaDaySearch.vue?vue&type=template&id=1ae45516"
import script from "./SpaDaySearch.vue?vue&type=script&lang=js"
export * from "./SpaDaySearch.vue?vue&type=script&lang=js"

import "./SpaDaySearch.vue?vue&type=style&index=0&id=1ae45516&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__